declare global {
  interface Window {
    clarity: ((...args: unknown[]) => void) & { q?: unknown[][] };
  }
}

export function initClarity() {
  const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID;
  if (!projectId) return;

  // Queue calls made before the script loads
  window.clarity =
    window.clarity ||
    ((...args: unknown[]) => {
      if (!window.clarity.q) {
        window.clarity.q = [];
      }
      window.clarity.q.push(args);
    });

  // Dynamically load the Clarity script — avoids unsafe-inline in CSP
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${projectId}`;
  document.head.appendChild(script);
}

export function clarityEvent(name: string) {
  if (typeof window.clarity !== 'function') return;
  window.clarity('event', name);
}

export function clarityTag(key: string, value: string) {
  if (typeof window.clarity !== 'function') return;
  window.clarity('set', key, value);
}
